import { useFlag } from '@openfeature/react-sdk';
import { FEATURE_FLAGS } from '../../constants/constants';

// REMOVE(settings-users-and-access): Drop flag gate; always use RBAC when flag is retired.
function usePermissionsMode() {
  const { value: isRbacEnabled } = useFlag(FEATURE_FLAGS.SETTINGS_USERS_AND_ACCESS, false);

  return { isRbacEnabled };
}

export default usePermissionsMode;
